import script from "./SanctionView.vue?vue&type=script&setup=true&lang=js"
export * from "./SanctionView.vue?vue&type=script&setup=true&lang=js"

import "./SanctionView.vue?vue&type=style&index=0&id=6fbfb4a9&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbfb4a9"]])

export default __exports__